import React from 'react';

const Friends = () => {
  const companions = [
    {
      id: 'lulu-valentine',
      name: 'Lulu Valentine',
      tagline: "Australia's Petite Eurasian",
      location: 'Sydney Based • International Touring',
      image: 'https://images.squarespace-cdn.com/content/v1/58d4b5fec534a598c8ca33c3/1739755879754-XU8LAVBMDU48GMSV9K8P/SILK8847-Edit-High-Res.jpg',
      website: 'https://www.lulu-valentine.com',
      description: 'Lulu brings an enchanting blend of elegance and warmth to every encounter. Her refined aesthetic and genuine connection make every moment unforgettable.'
    },
    {
      id: 'poppy-paisley',
      name: 'Poppy Paisley',
      tagline: 'Petite Brunette',
      location: 'Sydney',
      image: 'https://static.wixstatic.com/media/542dcb_a80a9b93e9cc4ab080ad25beb1445f82~mv2.jpg/v1/crop/x_0,y_6,w_3333,h_4989/fill/w_465,h_696,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Poppy%20blur-4.jpg',
      website: 'https://www.poppypaisleyx.com',
      description: 'Poppy embodies playful sophistication with her fun, flirty energy. She creates cheeky, memorable experiences filled with genuine laughter and connection.'
    }
  ];

  return (
    <div>
      {/* Page Header */}
      <section className="section-padding" style={{ paddingBottom: '60px' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Friends
            </h1>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-secondary)' }}>
              A curated collection of extraordinary women I'm honored to call friends. Each brings her own unique magic to the world of companionship. Whether you're seeking a solo experience with one of these incredible women or curious about a shared adventure, I trust them completely.
            </p>
          </div>
        </div>
      </section>

      {/* Companions Grid */}
      <section style={{ padding: '0 40px 120px' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: '48px',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {companions.map((companion) => (
              <div
                key={companion.id}
                style={{
                  background: 'var(--bg-primary)',
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(92, 64, 51, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                {/* Image */}
                <div style={{ 
                  width: '100%', 
                  height: '500px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <img
                    src={companion.image}
                    alt={companion.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: companion.imagePosition || 'center',
                      transition: 'transform 0.5s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  />
                </div>

                {/* Content */}
                <div style={{ padding: '32px' }}>
                  <h2 className="heading-2" style={{ marginBottom: '8px' }}>
                    {companion.name}
                  </h2>
                  <p className="body-regular" style={{ 
                    color: 'var(--burgundy)', 
                    marginBottom: '8px',
                    fontWeight: '500'
                  }}>
                    {companion.tagline}
                  </p>
                  <p className="body-small" style={{ 
                    color: 'var(--text-light)', 
                    marginBottom: '20px',
                    fontStyle: 'italic'
                  }}>
                    {companion.location}
                  </p>
                  <p className="body-regular" style={{ 
                    lineHeight: '1.7', 
                    marginBottom: '28px',
                    color: 'var(--text-secondary)'
                  }}>
                    {companion.description}
                  </p>

                  {/* Visit Website Button */}
                  <a
                    href={companion.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      padding: '14px 32px',
                      background: 'transparent',
                      color: 'var(--burgundy)',
                      border: '2px solid var(--burgundy)',
                      fontFamily: 'Raleway, sans-serif',
                      fontSize: '15px',
                      fontWeight: '600',
                      textDecoration: 'none',
                      letterSpacing: '0.5px',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'var(--burgundy)';
                      e.target.style.color = 'var(--ivory)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'transparent';
                      e.target.style.color = 'var(--burgundy)';
                    }}
                  >
                    Visit Website →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Optional: Collaboration CTA */}
      <section style={{ 
        padding: '80px 40px', 
        background: 'var(--bg-subtle)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Interested in a Shared Experience?
            </h2>
            <p className="body-large" style={{ 
              marginBottom: '32px', 
              lineHeight: '1.8', 
              color: 'var(--text-secondary)' 
            }}>
              If you're curious about spending time with both of us, or arranging an introduction to one of these beautiful souls, I'd love to help make that happen.
            </p>
            <a
              href="/bookings"
              style={{
                display: 'inline-block',
                padding: '16px 40px',
                background: 'var(--burgundy)',
                color: '#fff',
                border: '2px solid var(--burgundy)',
                fontFamily: 'Raleway, sans-serif',
                fontSize: '16px',
                fontWeight: '700',
                textDecoration: 'none',
                letterSpacing: '1px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'var(--burgundy)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'var(--burgundy)';
                e.target.style.color = '#fff';
              }}
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Friends;
